import styled from 'styled-components';
import CommonButton from 'components/Button';
import { Stack } from 'components/Stack';
import HelperText from 'components/HelperText';

const Container = styled(Stack)<{ isMobile: boolean }>`
  padding: ${({ isMobile }) => (isMobile ? '16px 10px' : '16px')};
`;

const DropOffDescriptionContainer = styled(Stack)``;

const NoteText = styled.div`
  margin-top: 8px;
  color: #000;
  font-size: 16px;
  line-height: 20px;
`;

const ActionWrapper = styled(Stack)`
  margin-top: 16px;
`;

const Button = styled(CommonButton)<{ isMobile: boolean }>`
  height: 100%;
  ${({ isMobile }) => isMobile && 'width: 100%;'}
  border-radius: 4px;
  font-weight: 700;
  font-size: 14px;
`;

export const ErrorMessage = styled(HelperText).attrs({
  isError: true,
})`
  display: block;
  margin-top: 8px;
`;

export {
  Container,
  DropOffDescriptionContainer,
  NoteText,
  ActionWrapper,
  Button,
};
